import { render } from "./sendListItem.vue?vue&type=template&id=cc9232cc&scoped=true"
import script from "./sendListItem.vue?vue&type=script&lang=js"
export * from "./sendListItem.vue?vue&type=script&lang=js"

import "./sendListItem.vue?vue&type=style&index=0&id=cc9232cc&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc9232cc"]])

export default __exports__